import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Container,Card,Grid} from '@mui/material';



const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'firstName', headerName: 'First name', width: 130 },
    { field: 'lastName', headerName: 'Last name', width: 130 },
    {
      field: 'age',
      headerName: 'Age',
      type: 'number',
      width: 90,
    },
    {
      field: 'fullName',
      headerName: 'Full name',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 160,
      valueGetter: (params) =>
        `${params.getValue(params.id, 'firstName') || ''} ${
          params.getValue(params.id, 'lastName') || ''
        }`,
    },
    {field: 'pic',
        headerName: 'Picture',
        cell: row => <div data-tag="allowRowEvents"><div ><img src={"/images/"+row.id} alt={row.pic}></img></div>{row.name}</div>,
        sortable: true,
        width: 160,
        height:300,
        renderCell: (params) => (
            <div data-tag="allowRowEvents"><div ><img src={"/images/"+params.getValue(params.id, 'pic')} alt={params.getValue(params.id, 'pic')} width="100px"height="100px"></img></div>{params.getValue(params.id, 'pic')}</div>
          ),

      },
  ];
  
  const rows = [
    { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35,pic:'airpods.jpg' },
    { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42,pic:'airpods.jpg' },
    { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45,pic:'airpods.jpg' },
    { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 ,pic:'airpods.jpg'},
    { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null,pic:'airpods.jpg' },
    { id: 6, lastName: 'Melisandre', firstName: null, age: 150,pic:'airpods.jpg' },
    { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44,pic:'airpods.jpg' },
    { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 ,pic:'airpods.jpg'},
    { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65,pic:'airpods.jpg' },
  ];

const DashboardAdmin = () => {
    return (
        <Container sx={{ mt: 8 }} maxWidth="xl"  >
<div style={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        checkboxSelection
      />
    </div>
    </Container>
    )
}

export default DashboardAdmin
